module.exports = __webpack_public_path__ + "static/media/research_main_img.d6d03df4.png";